import { styled, SxProps } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { EmtTypography } from "./EmtTypography";
import { EmtAvatar } from "./EmtAvatar";
import { EmtIcon } from "./EmtIcon";
import { EmtTheme } from "../types";

export type EmtProfilBoxProps = {
  sx?: SxProps;
  username?: string;
  secondaryLine?: string;
  avatarUrl?: string;
  nonce?: string;
};

const ProfilBox = styled(Box)(({ theme }: { theme?: EmtTheme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  padding: "16px",
  background: `linear-gradient(132.78deg, ${theme?.palette.primary.main} 25.97%, ${theme?.palette.primary.light} 87.46%)`,
  borderRadius: "16px",
  color: "white",
}));

export function EmtProfilBox(props: EmtProfilBoxProps) {
  const { username, secondaryLine, avatarUrl, ...rest } = props;
  return (
    <ProfilBox {...rest}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <EmtAvatar id="profil-avatar" variant="rounded" src={avatarUrl} />
        <EmtTypography
          variant="body2"
          fontWeight="bold"
          sx={{ display: "flex", flexDirection: "column" }}
        >
          {username}
          {secondaryLine && (
            <EmtTypography variant="caption" fontWeight={600}>
              {secondaryLine}
            </EmtTypography>
          )}
        </EmtTypography>
      </Box>
      <EmtIcon className="emt-right-1" />
    </ProfilBox>
  );
}
